<button
  class="{{ type }}"
  [disabled]="disable"
  [ngClass]="{
    disable: disable,
    small: size === eButtonSizes.s,
    medium: size === eButtonSizes.m,
    active: select,
    fill: spaceFilling
  }"
  (click)="handleSubmit()"
  (mouseenter)="isHover = true"
  (mouseleave)="isHover = false">
  <div class="content">
    <div *ngIf="firstIcon" class="flexCenter">
      <atm-icon
        [cursorType]="disable ? eCursorType.notAllowed : eCursorType.pointer"
        [enableForceHover]="type === eButtonTypes.secondary || type === eButtonTypes.tertiary"
        [iconKey]="firstIcon"
        [isHover]="disable ? false : select ? true : isHover"
        [size]="size === eButtonSizes.s ? eIconSizes.Size20 : eIconSizes.Size24"
        [statusIcon]="handleStatusIcon()">
      </atm-icon>
    </div>
    <div class="text"
      ><atm-text-ui
        [cursorType]="disable ? eCursorType.notAllowed : eCursorType.pointer"
        [fontColor]="colorBtn[disable ? eFontColor.disable : type]"
        [fontWeight]="eFontWeight.medium"
        ><ng-content></ng-content></atm-text-ui
    ></div>
    <div *ngIf="secondIcon" class="flexCenter">
      <atm-icon
        [cursorType]="disable ? eCursorType.notAllowed : eCursorType.pointer"
        [enableForceHover]="type === eButtonTypes.secondary || type === eButtonTypes.tertiary"
        [iconKey]="secondIcon"
        [isHover]="disable ? false : select ? true : isHover"
        [size]="size === eButtonSizes.s ? eIconSizes.Size20 : eIconSizes.Size24"
        [statusIcon]="handleStatusIcon()">
      </atm-icon>
    </div>
  </div>
</button>
